import {ice} from 'icepath'
import {AJAX_ERROR} from 'startlibs'

const erorrsOrSuccess = (success,errors) => Object.keys(errors).length ? {errors} : success

export const required = (s, k) => !s && 'Required field(s).'

export const minLength = (n) => (s, k) => s && s.length < n && `Field must have at least ${n} characters.`

export const confirmPasswords = (passwordKey) => (confirm, k, props) => props[passwordKey] !== confirm && 'Passwords didn\'t match, try again.'
export const confirmEmail = (passwordKey) => (confirm, k, props) => props[passwordKey] !== confirm && 'Email didn\'t match, try again.'

const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
export const emailValidation = (s, k) => !emailRegex.test(s) && 'Invalid e-mail.'

export const buildValidation = (validations,transform) => (props) =>
  erorrsOrSuccess({success: transform ? transform(props) : props},
    ice(validations)
      .map((v, k) => [].concat(v).map(fn => fn(props[k], k, props)).filter(_ => _))
      .filter((v, k) => v.length)
      .value()
  )


export const responseFailure = (form,fn) => (_,{response}) => {
  const setErrors = form.connector.setErrors
  if (response) {
    const error = fn(response)
    if (error) {
      setErrors(error)
    } else {
      setErrors({"":[AJAX_ERROR]})
    }
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/validation.js